'use strict';

jQuery(document).ready(function ($) {
  $(window).load(function () {

    function validationSubscript() {

      if ($('.form-offer-subscription').length != 0) {
        formValidateConfig($('.form-offer-subscription'));

        var offerID = $('.jc-offer-header').attr("data-id");
        var cnpjElement = $('.cnpj');
        var cpfCnpjElement = $('.cpfcnpj');
        var cepElement = $('.cep');
        var phoneElement = $('.phone');

        validatorCep();
        maskCep(cepElement);
        validatorCnpj();
        maskCnpj(cnpjElement);
        maskCpfCnpj(cpfCnpjElement);

        validatorPhone();
        maskPhone(phoneElement);

        validatorCnpj();
        validatorCpfCnpj();
        validatorCep();

        $('button[name=offer-submit]').click(function (event) {
          event.preventDefault();
          if ($('.form-offer-subscription').valid()) {
            formSubscription(offerID);
          }
        });
      }
    }

    validationSubscript();

    $('#offer-form-modal').on('shown.bs.modal', function () {
      $(this).on('change', function () {
        validationSubscript();
        $(this).off('change');
      });
    });

    function formSubscription(offerID) {
      validatorConfig();

      var form = $('#form-offer-' + offerID);
      var phoneElement = form.find('.phone');

      formValidateConfig(form);
      maskPhone(phoneElement);
      validatorEmail();
      validatorPhone();

      var tempName = form.find('.name').val().trim(),
          fullName = tempName.replace(/( )+/g, ' '),
          name = fullName.split(' ')[0],
          surname = fullName.indexOf(' ') !== -1 ? fullName.substr(fullName.indexOf(' ') + 1) : '',
          email = form.find('.email').val(),
          phone = form.find('.phone').val(),
          oferta = offerID,
          cnpj = form.find('.cnpj').val(),
          cpf = form.find('.cpfcnpj').val(),
          cpfcnpjEncrypted = "",
          cep = form.find('.cep').val(),
          numberVehicles = form.find('input[name="qtdveiculos"]').val(),
          button = form.find('button[type="submit"]'),
          optIns = {},
          lgpd = [];

      form.find(".jc-opt-in").each(function () {
        optIns[$(this).attr('name')] = $(this).prop('checked');

        if ($(this).prop('checked')) {
          lgpd.push([$(this).attr('name'), $(this).parents(".form-group").text().trim(), $(this).parents(".form-group").find('a') ? $(this).parents(".form-group").find('a').map(function () {
            return $(this).attr('href');
          }).get() : null]);
        }
      });

      var buttonLabel = button.text();
      button.prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');

      var urlParams = new URLSearchParams(window.location.search);

      grecaptcha.enterprise.ready(function () {
        grecaptcha.enterprise.execute(ajaxHandler.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {
          $.ajax({
            url: 'https://leadspublidigital.estadao.com.br/api/jornaldocarro/v1/receive-callback-subscription',
            type: 'POST',
            data: {
              action: 'jc_ajax_offer_save_lead_subscription',
              context: window.location.pathname.indexOf("carros-0km") > -1 ? 'catalogo-0km' : 'lead',
              name: name,
              surname: surname,
              email: email,
              phone: phone,
              cpfcnpj: cnpj ? cnpj : cpf,
              cpfcnpjEncrypted: cpfcnpjEncrypted,
              cep: cep,
              oferta: oferta,
              is_subscription: true,
              url_page: window.location.href,
              numberVehicles: numberVehicles,
              optIns: encodeURIComponent(JSON.stringify(optIns)),
              lgpd: encodeURIComponent(JSON.stringify(lgpd)),
              getParameters: encodeURIComponent(JSON.stringify(getUrlVars())),
              token: grecaptchaToken
            },
            success: function success(response) {
              if (response && response.success) {
                var leadID = response.data.leadID;
                setLeadIdSessionStorage(leadID);
                send_offer_lead_success_events(offerID, leadID, 'Oferta');
                gtm_get_data_and_send_lead_saved(leadID, 'landingPage').then(function () {
                  if (window.location.pathname.indexOf("oferta") > -1) {
                    window.location.href += (window.location.href.indexOf("?") > -1 ? '&' : '?') + 'pagina=obrigado&id=' + leadID;
                  } else {
                    loadThankYouPage(leadID, offerID, $('#offer-form-modal .offer-form'));
                  }
                });
              } else {
                send_offer_lead_error_events();
                populateAndShowFormError(form, response.data);
                button.prop('disabled', false).html(buttonLabel);
              }
            },
            error: function error(data) {
              showFormError(form);
              button.prop('disabled', false).html(buttonLabel);
            }
          });
        });
      });
    }

    var loadThankYouPage = function loadThankYouPage(leadID, offerID, offerForm) {
      $.ajax({
        url: ajaxHandler.url,
        type: 'POST',
        data: {
          // action: 'jc_ajax_ad_thank_you_page_content',
          action: 'jc_ajax_modal_thank_you_page_content',
          offerID: offerID,
          leadID: leadID
        },
        success: function success(response) {
          if (response && response.success) {
            offerForm.trigger('thankYouPageLoaded');
            offerForm.html(response.data.template);
          }
        }
      });
    };
  });
});